import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';
import { SharedModule } from '../shared/shared.module';
import { AgentPanelComponent } from './agent-panel/agent-panel.component';
import { AgentLauncherButtonComponent } from './agent-launcher-button/agent-launcher-button.component';
import { AgentMessageListComponent } from './agent-message-list/agent-message-list.component';
import { AgentHistoryComponent } from './agent-history/agent-history.component';
import { AgentToolCallComponent } from './agent-tool-call/agent-tool-call.component';
import { AgentToolResultComponent } from './agent-tool-result/agent-tool-result.component';
import { AgentToolResultNodeComponent } from './agent-tool-result-node/agent-tool-result-node.component';
import { AgentTemplatePickerComponent } from './agent-template-picker/agent-template-picker.component';
import { AgentAudienceListComponent } from './agent-audience-list/agent-audience-list.component';
import { AgentConfirmationComponent } from './agent-confirmation/agent-confirmation.component';
import { AgentThinkingComponent } from './agent-thinking/agent-thinking.component';

@NgModule({
  declarations: [
    AgentPanelComponent,
    AgentLauncherButtonComponent,
    AgentMessageListComponent,
    AgentHistoryComponent,
    AgentToolCallComponent,
    AgentToolResultComponent,
    AgentToolResultNodeComponent,
    AgentTemplatePickerComponent,
    AgentAudienceListComponent,
    AgentConfirmationComponent,
    AgentThinkingComponent,
  ],
  imports: [SharedModule, ReactiveFormsModule, TextFieldModule],
  exports: [AgentPanelComponent, AgentLauncherButtonComponent],
})
export class AgentsModule {}
